/**
 * gfe-availability.js
 * Gears For Ears – Availability / Dispatch Message
 */

(function () {
  'use strict';

  var DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  function initAvailability(wrapper) {
    var sectionId = wrapper.dataset.section;

    function getTemplate(id) {
      var el = document.getElementById(id);
      if (!el) return '';
      var html = el.innerHTML.trim();
      return html
        .replace(/^<p>/i, '')
        .replace(/<\/p>$/i, '')
        .replace(/<\/p>\s*<p>/gi, '<br>');
    }

    var cfg = {
      cutoffHour:          parseInt(wrapper.dataset.cutoffHour, 10) || 14,
      closedDay:           parseInt(wrapper.dataset.closedDay, 10),
      msgBefore:           getTemplate('gfe-tpl-before-' + sectionId),
      msgAfter:            getTemplate('gfe-tpl-after-' + sectionId),
      msgComingSoon:       getTemplate('gfe-tpl-coming-soon-' + sectionId),
      msgPreorder:         getTemplate('gfe-tpl-preorder-' + sectionId),
      preorderDays:        parseInt(wrapper.dataset.preorderDays, 10) || 20,
      msgPreorderExpress:  getTemplate('gfe-tpl-express-' + sectionId),
      preorderExpressDays: parseInt(wrapper.dataset.preorderExpressDays, 10) || 10,
      msgPreorderUsa:      getTemplate('gfe-tpl-usa-' + sectionId),
      preorderUsaDays:     parseInt(wrapper.dataset.preorderUsaDays, 10) || 45,
      contactUrl:          wrapper.dataset.contactUrl || '/pages/contact-us',
      contactText:         wrapper.dataset.contactText || 'Contact Us',
    };

    var inventory = {};
    (wrapper.dataset.variantInventory || '').split(',').forEach(function (pair) {
      var parts = pair.split(':');
      if (parts.length === 2) {
        inventory[parts[0].trim()] = parseInt(parts[1].trim(), 10);
      }
    });

    var productTags = (wrapper.dataset.productTags || '').split('|').map(function (t) {
      return t.trim();
    });

    var messageEl = wrapper.querySelector('.gfe-availability-message');
    var currentVariantId = wrapper.dataset.initialVariant;

    function getCutoffTimeString() {
      var h = cfg.cutoffHour;
      var ampm = h >= 12 ? 'PM' : 'AM';
      var h12 = h % 12 || 12;
      return h12 + ':00 ' + ampm;
    }

    // Returns the Date of the next dispatch cutoff (accounts for closed day)
    function getNextDispatchDate() {
      var now = new Date();
      var dayIndex = now.getDay();
      var currentHourFraction = now.getHours() + now.getMinutes() / 60;
      var daysAhead = (currentHourFraction < cfg.cutoffHour) ? 0 : 1;
      var targetDayIndex = (dayIndex + daysAhead) % 7;
      var safety = 0;
      while (targetDayIndex === cfg.closedDay && safety < 7) {
        daysAhead++;
        targetDayIndex = (dayIndex + daysAhead) % 7;
        safety++;
      }
      var dispatchDate = new Date(now);
      dispatchDate.setDate(dispatchDate.getDate() + daysAhead);
      dispatchDate.setHours(cfg.cutoffHour, 0, 0, 0);
      return dispatchDate;
    }

    function getNextDispatchDay() {
      return DAY_NAMES[getNextDispatchDate().getDay()];
    }

    // Countdown to today's cutoff (before cutoff only)
    function getCountdownString() {
      var now = new Date();
      var cutoff = new Date(now);
      cutoff.setHours(cfg.cutoffHour, 0, 0, 0);
      var diff = cutoff - now;
      if (diff <= 0) return null;
      var hours = Math.floor(diff / 3600000);
      var mins = Math.floor((diff % 3600000) / 60000);
      if (hours > 0) return hours + 'h ' + mins + 'm';
      return mins + 'm';
    }

    // Countdown to next dispatch day's cutoff (after cutoff)
    function getNextCutoffCountdown() {
      var now = new Date();
      var diff = getNextDispatchDate() - now;
      if (diff <= 0) return null;
      var hours = Math.floor(diff / 3600000);
      var mins = Math.floor((diff % 3600000) / 60000);
      if (hours > 0) return hours + 'h ' + mins + 'm';
      return mins + 'm';
    }

    function isBeforeCutoff() {
      var now = new Date();
      return (now.getHours() + now.getMinutes() / 60) < cfg.cutoffHour;
    }

    function getPreorderType() {
      if (productTags.indexOf('pre-order usa') !== -1)     return 'usa';
      if (productTags.indexOf('pre-order express') !== -1) return 'express';
      if (productTags.indexOf('pre-order') !== -1)         return 'standard';
      return null;
    }

    function makeContactLink() {
      return '<a href="' + cfg.contactUrl + '">' + cfg.contactText + '</a>';
    }

    function render(variantId) {
      currentVariantId = variantId;
      var variantIdStr = String(variantId);
      var qty = inventory.hasOwnProperty(variantIdStr) ? inventory[variantIdStr] : null;
      var preorderType = getPreorderType();
      var inStock = (qty !== null && qty > 0);
      var html = '', cssState = '';

      if (inStock) {
        cssState = 'gfe-availability--instock';
        if (isBeforeCutoff()) {
          var countdown = getCountdownString();
          var timeDisplay = countdown
            ? '<span class="gfe-countdown">' + countdown + '</span>'
            : getCutoffTimeString();
          html = cfg.msgBefore.replace(/\{time\}/g, timeDisplay);
        } else {
          var dispatchDay = getNextDispatchDay();
          var nextCountdown = getNextCutoffCountdown();
          var timeDisplay = nextCountdown
            ? '<span class="gfe-countdown">' + nextCountdown + '</span>'
            : getCutoffTimeString();
          html = cfg.msgAfter
            .replace(/\{time\}/g, timeDisplay)
            .replace(/\{day\}/g, dispatchDay);
        }
      } else if (productTags.indexOf('pre-book') !== -1 && cfg.msgComingSoon) {
        // GFE: pre-book message. Shows when the product is tagged 'pre-book' and
        // the selected variant is out of stock — mirrors the "Pre-Book" button.
        // Takes PRIORITY over pre-order (checked first).
        cssState = 'gfe-availability--preorder';
        html = cfg.msgComingSoon
          .replace(/\{contact_link\}/g, makeContactLink());
      } else if (preorderType) {
        cssState = 'gfe-availability--preorder';
        var contactLink = makeContactLink();
        var template, days;
        if (preorderType === 'usa') {
          template = cfg.msgPreorderUsa; days = cfg.preorderUsaDays;
        } else if (preorderType === 'express') {
          template = cfg.msgPreorderExpress; days = cfg.preorderExpressDays;
        } else {
          template = cfg.msgPreorder; days = cfg.preorderDays;
        }
        html = template.replace(/\{days\}/g, days).replace(/\{contact_link\}/g, contactLink);
      } else {
        wrapper.style.display = 'none';
        return;
      }

      messageEl.className = 'gfe-availability-message ' + cssState;
      messageEl.innerHTML = '<span>' + html + '</span>';
      wrapper.style.display = '';
    }

    render(wrapper.dataset.initialVariant);

    // Re-render every minute to keep countdowns live (both before and after cutoff)
    setInterval(function () {
      if (currentVariantId) render(currentVariantId);
    }, 60000);

    var productSection = document.getElementById('shopify-section-' + sectionId)
      || document.querySelector('[data-section-id="' + sectionId + '"]')
      || document;

    // Match wrapper width to the visible right edge of the buy-buttons row.
    // .product-actions is width:100% but its flex children don't fill it,
    // so we measure the right edge of the last child instead.
    // We also apply the same width to the star-rating float container so the
    // star's right edge aligns with the button's right edge.
    var productActionsEl = productSection.querySelector('.product-actions');
    if (productActionsEl) {
      function syncWidth() {
        var children = productActionsEl.children;
        if (!children.length) return;
        var containerLeft = productActionsEl.getBoundingClientRect().left;
        var lastChild = children[children.length - 1];
        var lastChildRight = lastChild.getBoundingClientRect().right;
        var contentWidth = lastChildRight - containerLeft;
        if (contentWidth > 0) {
          // Availability bar
          wrapper.style.maxWidth = contentWidth + 'px';
          // Star rating float container — constrain so float:right aligns with button right edge
          var priceBlock = productSection.querySelector('.product-block-price');
          if (priceBlock) {
            var priceMeta = priceBlock.querySelector('.product-info-meta');
            if (priceMeta) priceMeta.style.width = contentWidth + 'px';
          }
        }
      }
      syncWidth();
      if (window.ResizeObserver) {
        new ResizeObserver(syncWidth).observe(productActionsEl);
      }
    }

    productSection.addEventListener('change', function (e) {
      var target = e.target;
      if (target && target.dataset && target.dataset.variantId && target.checked !== false) {
        render(target.dataset.variantId); return;
      }
      if (target && target.tagName === 'SELECT') {
        var selectedOption = target.options[target.selectedIndex];
        if (selectedOption && selectedOption.dataset.variantId) {
          render(selectedOption.dataset.variantId); return;
        }
      }
      if (target && target.name === 'id') render(target.value);
    });

    var productForm = document.querySelector('form[id^="product-form-"]')
      || document.querySelector('form[action*="/cart/add"]');
    if (productForm) {
      var hiddenId = productForm.querySelector('input[name="id"]');
      if (hiddenId) {
        new MutationObserver(function (mutations) {
          mutations.forEach(function (m) {
            if (m.attributeName === 'value') render(hiddenId.value);
          });
        }).observe(hiddenId, { attributes: true });
      }
    }

    document.addEventListener('variant:change', function (e) {
      if (e.detail && e.detail.variant && e.detail.variant.id) render(e.detail.variant.id);
    });
    document.addEventListener('variantChange', function (e) {
      if (e.detail && e.detail.variant && e.detail.variant.id) render(e.detail.variant.id);
    });
  }

  function boot() {
    document.querySelectorAll('.gfe-availability-wrapper').forEach(initAvailability);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();
